// extracted by mini-css-extract-plugin
export default {"sources-container":"CountrySources_sources-container__KVPZn","sources-title":"CountrySources_sources-title__-dMBc","sources-links":"CountrySources_sources-links__rwDPz"};